import React from "react";
import { Route, Switch } from "react-router-dom";

import Report from "./containers/Report";
import Create from "./containers/Create";
import Details from "./containers/Details";
import Edit from "./containers/Edit";

const routes = () => {
  return (
    <React.Fragment>
      <Switch>
        <Route exact path="/subscriptions/new" component={Create} />
        <Route exact path="/subscriptions" component={Report} />
        <Route exact path="/subscriptions/:id" component={Details} />
        <Route exact path="/subscriptions/:id/edit" component={Edit} />
      </Switch>
    </React.Fragment>
  );
};

export default routes;
